module.exports = __webpack_public_path__ + "media/images/recruit/description/logo-360-ac00223bae1b5e9873f12f0e3f645235.png";